import { createSelector } from 'reselect';

// Config
import { getRouterLocationSearchSelector } from '../../redux/reducers/router/routerSelector';

const auth0CallbackGuestState = createSelector(
  [getRouterLocationSearchSelector],
  (searchLocation) => {
    const searchParams = new URLSearchParams(searchLocation);
    const query = Object.fromEntries(searchParams);

    return query.email;
  },
);

export default auth0CallbackGuestState;
